import ApiProvider from 'libs/providers/api/api.provider';
import { Observable } from 'rxjs';

const BASE_URL = String(import.meta.env.VITE_APP_SERVER_TOKEN_URL);
const API_RESOURCE = String(import.meta.env.VITE_APP_API_RESOURCE);

class TokenProvider {
  constructor(private readonly _provider: ApiProvider = new ApiProvider()) {}

  generate(): Observable<any> {
    return this._provider.post(
      `${BASE_URL}/ecommerce-autos/auth/v2/token/`,
      {
        resource: API_RESOURCE,
      },
      {},
    );
  }
}
export default TokenProvider;
